import { css, cx } from '@eti/styles';
import { breakpoints } from '@etg/wings';
import { jsx as _jsx } from "react/jsx-runtime";
const contentWrapperStyles = css`
  margin: 0 auto;
  padding: 0 10px;
  width: 100%;

  @media (min-width: ${breakpoints._768}) {
    max-width: 750px;
    padding: 0 15px;
  }

  @media (min-width: ${breakpoints._970}) {
    max-width: 970px;
  }

  @media (min-width: ${breakpoints._1170}) {
    max-width: 1170px;
  }
`;
const ContentWrapper = ({
  children,
  className,
  dataTestId,
  customRef
}) => /*#__PURE__*/_jsx("div", {
  className: cx('etiContentWrapper', contentWrapperStyles, className),
  "data-testid": dataTestId,
  ref: customRef,
  children: children
});
export default ContentWrapper;
//# sourceMappingURL=ContentWrapper.js.map